import React, { useState } from 'react';

import alubiasCat from '../../assets/images/productos/catalogo/Alubias1kg.png';
import infoalubias from '../../assets/images/nutrmental/CF/alubias.jpg';
import flormayoCat from '../../assets/images/productos/catalogo/FlorDeMayo1kg.png';
import infoFlorMayo from '../../assets/images/nutrmental/CF/florMayo.jpg';
import frijolperuCat from '../../assets/images/productos/catalogo/FrijolPeruano900g.png';
import infoFrijolPe from '../../assets/images/nutrmental/CF/frijolperuano.jpg';
import garbanzoCat from '../../assets/images/productos/catalogo/Garbanzo500g.png';
import infoGarbanzo from '../../assets/images/nutrmental/CF/garbanzo.jpg';
import habaCat from '../../assets/images/productos/catalogo/Haba500g.png';
import infoHaba from '../../assets/images/nutrmental/CF/haba.jpg';
import lentejaCat from '../../assets/images/productos/catalogo/Lenteja500g.png';
import infoLenteja from '../../assets/images/nutrmental/CF/lenteja.jpg';
import pintoCat from '../../assets/images/productos/catalogo/Pinto900g.png';
import infoFrijolPi from '../../assets/images/nutrmental/CF/frijolpinto.jpg';
import avenaCat from '../../assets/images/productos/catalogo/Avena.png';
import infoAvena from '../../assets/images/nutrmental/CF/hojuelAvena.jpg';
import frijolNegCat from '../../assets/images/productos/catalogo/FrijolNegro.png';
import infoFrijolN from '../../assets/images/nutrmental/CF/frijolnegro.jpg';
import maizPaloCat from '../../assets/images/productos/catalogo/MaizPalomero.png';
import arrozCat from '../../assets/images/productos/catalogo/Arroz.png';
import infoArroz from '../../assets/images/nutrmental/CF/arroz.jpg';
import frijolesBayosCat from '../../assets/images/productos/catalogo/Frijoles Bayos.png';
import infoFrijolesB from '../../assets/images/nutrmental/CF/frijolBayo.jpg';
import soyaRescat from '../../assets/images/productos/catalogo/Soya de res.png';
import soyaNatCat from '../../assets/images/productos/catalogo/Soya.png';

const ProductCatalog = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);
  // Zoom state for nutritional info images
  const [nutritionalOrigin, setNutritionalOrigin] = useState('50% 50%');
  const [zoomLevel, setZoomLevel] = useState(1);
  const zoomScale = 2.0; // adjust max zoom
  const handleNutritionalMove = e => {
    const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;
    setNutritionalOrigin(`${x}% ${y}%`);
  };
  const resetNutritional = () => setNutritionalOrigin('50% 50%');

  const productos = [
        {
      nombre: "Hojuela de Avena",
      descripcion: "Avena natural, ideal para desayunos y repostería.",
      imagen: avenaCat,
      presentacion: "Bolsa 400g, Bolsa 250g, Bolsa 1kg",
      color: "from-yellow-100 to-yellow-200",
      beneficios: ["Fuente de fibra", "Energía natural", "Versátil"],
      usos: ["Atole", "Galletas", "Desayunos"]
    },
        {
      nombre: "Lentejas ",
      descripcion: "Lenteja seleccionada, rápida cocción y excelente sabor.",
      imagen: lentejaCat,
      presentacion: "Bolsa 500g, Bolsa 250g",
      color: "from-orange-200 to-orange-400",
      beneficios: ["Cocción rápida", "Rica en hierro", "Sabor intenso"],
      usos: ["Sopas", "Curry", "Ensaladas"]
    },
        {
      nombre: "Frijol Pinto",
      descripcion: "Frijol pinto, tradicional en la cocina mexicana.",
      imagen: pintoCat,
      presentacion: "Bolsa 900g",
      color: "from-brown-200 to-brown-400",
      beneficios: ["Sabor tradicional", "Textura firme", "Muy nutritivo"],
      usos: ["Frijoles charros", "Burritos", "Chili"]
    },

    {
      nombre: "Frijol Negro",
      descripcion: "Frijol negro seleccionado, sabor intenso y textura suave.",
      imagen: frijolNegCat,
      presentacion: "Bolsa 500g",
      color: "from-gray-800 to-gray-900",
      beneficios: ["Rico en antioxidantes", "Textura suave", "Sabor intenso"],
      usos: ["Sopas", "Ensaladas", "Platillos mexicanos"]
    },
    {
      nombre: "Alubias ",
      descripcion: "Alubias blancas seleccionadas, ideales para platillos tradicionales.",
      imagen: alubiasCat,
      presentacion: "Bolsa 1kg",
      color: "from-gray-100 to-gray-300",
      beneficios: ["Rica en proteínas", "Fácil cocción", "Sabor tradicional"],
      usos: ["Sopas", "Guisos", "Ensaladas"]
    },
    {
      nombre: "Frijol Flor de Mayo",
      descripcion: "Frijol Flor de Mayo de excelente calidad, suave y delicioso.",
      imagen: flormayoCat,
      presentacion: "Bolsa 1kg",
      color: "from-pink-200 to-pink-400",
      beneficios: ["Textura cremosa", "Sabor suave", "Versatilidad culinaria"],
      usos: ["Frijoles refritos", "Platillos mexicanos", "Sopas"]
    },
    {
      nombre: "Frijol Peruano ",
      descripcion: "Frijol peruano, cremoso y versátil para diferentes recetas.",
      imagen: frijolperuCat,
      presentacion: "Bolsa 900g",
      color: "from-yellow-200 to-yellow-400",
      beneficios: ["Cremoso", "Versátil", "Nutritivo"],
      usos: ["Ensaladas", "Platillos principales", "Guarniciones"]
    },
    {
      nombre: "Garbanzo",
      descripcion: "Garbanzo de grano grande, ideal para ensaladas y guisos.",
      imagen: garbanzoCat,
      presentacion: "Bolsa 500g",
      color: "from-yellow-100 to-yellow-300",
      beneficios: ["Alto en fibra", "Grano grande", "Versátil"],
      usos: ["Hummus", "Ensaladas", "Currys"]
    },
    {
      nombre: "Haba ",
      descripcion: "Haba seca de alta calidad, fuente de proteína vegetal.",
      imagen: habaCat,
      presentacion: "Bolsa 500g",
      color: "from-green-100 to-green-300",
      beneficios: ["Rica en proteínas", "Fuente de hierro", "Tradicional"],
      usos: ["Sopas", "Puré", "Guisos"]
    },
    {
      nombre: "Maíz Palomero",
      descripcion: "Maíz especial para palomitas, granos grandes y crujientes.",
      imagen: maizPaloCat,
      presentacion: "Bolsa 500g",
      color: "from-yellow-300 to-yellow-500",
      beneficios: ["Granos grandes", "Crujiente", "Natural"],
      usos: ["Palomitas", "Snacks"]
    },
    {
      nombre: "Arroz",
      descripcion: "Arroz de grano largo, suelto y fragante, ideal para acompañar tus platillos.",
      imagen: arrozCat,
      presentacion: "Bolsa 1kg, Bolsa 500g",
      color: "from-green-200 to-green-300",
      beneficios: ["Grano suelto", "Fácil de cocinar", "Sabor neutro"],
      usos: ["Acompañante", "Sopas", "Ensaladas"]
    },
    {
      nombre: "Frijoles Bayos",
      descripcion: "Frijoles bayos seleccionados, de sabor suave y textura cremosa.",
      imagen: frijolesBayosCat,
      presentacion: "Bolsa 900g",
      color: "from-beige-200 to-beige-400",
      beneficios: ["Ricos en fibra", "Sabor suave", "Textura cremosa"],
      usos: ["Sopas", "Guisos", "Ensaladas"]
    },
    {
      nombre: "Soya de Res",
      descripcion: "Soya de Res, alta en proteínas y con bajo impacto ambiental.",
      imagen: soyaRescat,
      presentacion: "Bolsa 500g",
      color: "from-indigo-200 to-indigo-400",
      beneficios: ["Alto contenido proteico", "Bajo en grasas", "Sostenible"],
      usos: ["Hamburguesas", "Sopas", "Guisos"]
    },
    {
      nombre: "Soya Natural",
      descripcion: "Soya natural, fuente de proteína vegetal de alta calidad.",
      imagen: soyaNatCat,
      presentacion: "Bolsa 500g",
      color: "from-purple-200 to-purple-400",
      beneficios: ["Proteína completa", "Bajo índice glucémico", "Versátil"],
      usos: ["Tofu", "Leche de soya", "Sopas"]
    },
  ];

  const handleVerDetalles = (producto) => {
    setProductoSeleccionado(producto);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setProductoSeleccionado(null);
  };

  // Función para determinar color de texto del header según fondo
  const getHeaderTextColor = (color) => {
    const lightKeywords = ['yellow','orange','gray-100','pink','green-100','brown', 'beige', 'indigo', 'purple'];
    return lightKeywords.some(keyword => color.includes(keyword)) ? 'text-gray-800' : 'text-white';
  };

  return (
    <div id="productos-catalogo" className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Catálogo de <span className="text-green-600">Productos</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ofrecemos una amplia variedad de granos, semillas y especias mexicanas, 
            todos con los más altos estándares de calidad.
          </p>
        </div>
       
        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {productos.map((producto, index) => (
            <div 
              key={producto.nombre}
              className="group bg-white rounded-3xl shadow-2xl hover:shadow-3xl transition-all duration-700 overflow-hidden transform hover:scale-[1.02] border border-gray-100"
              style={{ 
                animationDelay: `${index * 0.1}s`,
                animation: 'fadeInUp 0.6s ease-out forwards'
              }}
            >
              {/* Imagen del producto */}
              <div className={`h-48 bg-gradient-to-br ${producto.color} flex items-center justify-center relative overflow-hidden`}>
                <img 
                  src={producto.imagen} 
                  alt={producto.nombre}
                  className="w-full h-full object-contain p-4 group-hover:scale-110 transition-transform duration-700 drop-shadow-2xl"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
                
                {/* Indicador de calidad */}
                <div className="absolute bottom-3 right-3 bg-white/90 text-gray-800 px-2 py-1 rounded-full text-xs font-semibold shadow-lg">
                  ✓ PREMIUM
                </div>
              </div>
              
              {/* Información del producto */}
              <div className="p-5">
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-green-600 transition-colors duration-300">
                  {producto.nombre}
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed text-xs">
                  {producto.descripcion}
                </p>
                
                {/* Características del producto */}
                <div className="space-y-1 mb-4">
                  <div className="flex items-center text-green-700">
                    <span className="w-1.5 h-1.5 bg-green-500 rounded-full mr-2"></span>
                    <span className="font-medium text-xs">100% natural</span>
                  </div>
                  <div className="flex items-center text-green-700">
                    <span className="w-1.5 h-1.5 bg-green-500 rounded-full mr-2"></span>
                    <span className="font-medium text-xs">Certificado</span>
                  </div>
                  <div className="flex items-center text-green-700">
                    <span className="w-1.5 h-1.5 bg-green-500 rounded-full mr-2"></span>
                    <span className="font-medium text-xs">Empaque hermético</span>
                  </div>
                </div>
                
                {/* Footer del producto */}
                <div className="flex flex-col gap-2">
                  <span className="text-xs font-bold px-3 py-1.5 rounded-full border-2 text-green-600 bg-green-50 border-green-300 text-center">
                    📦 {producto.presentacion}
                  </span>
                  <button 
                    onClick={() => handleVerDetalles(producto)}
                    className="font-bold px-4 py-1.5 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg bg-green-500 hover:bg-green-600 text-white text-xs"
                  >
                    Ver detalles →
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal Mejorado */}
      {modalOpen && productoSeleccionado && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm p-2 overflow-auto">
          <div className="bg-white rounded-3xl shadow-2xl w-full mx-4 sm:mx-auto max-w-xs sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl max-h-[85vh] overflow-y-auto relative transform transition-all duration-300 scale-100 opacity-100">
            {/* Header del Modal */}
            <div className={`h-24 sm:h-32 bg-gradient-to-br ${productoSeleccionado.color} relative overflow-hidden rounded-t-3xl flex items-center justify-between px-6 sm:px-8`}> 
              <div className="absolute inset-0 bg-gradient-to-r from-black/20 to-transparent"></div>
              {/* Badge Premium */}
              <div className="absolute top-4 left-4 bg-white/90 text-gray-800 px-3 py-1 rounded-full text-sm font-semibold shadow-lg backdrop-blur-sm z-10">
                ✓ PREMIUM
              </div>
              {/* Nombre del producto en el header (antes imagen) */}
              <div className="relative z-10 flex items-center justify-center h-full w-full">
                <h3 className={`text-3xl font-bold ${getHeaderTextColor(productoSeleccionado.color)} text-center drop-shadow-2xl`}>
                  {productoSeleccionado.nombre}
                </h3>
              </div>
              <button
                onClick={closeModal}
                className="absolute top-4 right-4 w-10 h-10 bg-white/90 hover:bg-white text-gray-600 hover:text-red-500 rounded-full flex items-center justify-center transition-all duration-300 shadow-lg hover:shadow-xl backdrop-blur-sm z-10"
                aria-label="Cerrar"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Contenido del Modal */}
            <div className="p-4 relative"> {/* Menos padding para menos espacio libre */}
              {/* Información principal con imágenes lado a lado */}
              <div className="text-center mb-8">
                <p className="text-gray-600 text-lg leading-relaxed max-w-lg mx-auto mb-4">
                  {productoSeleccionado.descripcion}
                </p>
                <div className="flex flex-col items-center md:flex-row md:justify-center md:space-x-6">
                  {/* Imagen del producto */}
                  <img
                    src={productoSeleccionado.imagen}
                    alt={productoSeleccionado.nombre}
                    className="h-40 w-auto object-contain drop-shadow-lg mb-4 md:mb-0"
                  />
                  {/* Información nutrimental */}
                  {productoSeleccionado.nombre === 'Alubias ' && (
                    <div className="h-40 w-auto overflow-hidden rounded-md shadow-lg cursor-zoom-in"
                         onMouseEnter={() => setZoomLevel(zoomScale)}
                         onMouseMove={handleNutritionalMove}
                         onMouseLeave={() => { resetNutritional(); setZoomLevel(1); }}>
                      <img src={infoalubias} alt="Información nutrimental Alubias"
                           className="h-full w-auto object-contain drop-shadow-lg filter grayscale transition-transform duration-300"
                           style={{ transformOrigin: nutritionalOrigin, transform: `scale(${zoomLevel})` }} />
                    </div>
                  )}
                  {productoSeleccionado.nombre === 'Frijol Flor de Mayo' && (
                    <div className="h-40 w-auto overflow-hidden rounded-md shadow-lg cursor-zoom-in"
                         onMouseEnter={() => setZoomLevel(zoomScale)}
                         onMouseMove={handleNutritionalMove}
                         onMouseLeave={() => { resetNutritional(); setZoomLevel(1); }}>
                      <img src={infoFlorMayo} alt="Información nutrimental Flor de Mayo"
                           className="h-full w-auto object-contain drop-shadow-lg filter grayscale transition-transform duration-300"
                           style={{ transformOrigin: nutritionalOrigin, transform: `scale(${zoomLevel})` }} />
                    </div>
                  )}
                  {productoSeleccionado.nombre === 'Frijol Peruano ' && (
                    <div className="h-40 w-auto overflow-hidden rounded-md shadow-lg cursor-zoom-in"
                         onMouseEnter={() => setZoomLevel(zoomScale)}
                         onMouseMove={handleNutritionalMove}
                         onMouseLeave={() => { resetNutritional(); setZoomLevel(1); }}>
                      <img src={infoFrijolPe} alt="Información nutrimental Frijol Peruano"
                           className="h-full w-auto object-contain drop-shadow-lg filter grayscale transition-transform duration-300"
                           style={{ transformOrigin: nutritionalOrigin, transform: `scale(${zoomLevel})` }} />
                    </div>
                  )}
                  {productoSeleccionado.nombre === 'Garbanzo' && (
                    <div className="h-40 w-auto overflow-hidden rounded-md shadow-lg cursor-zoom-in"
                         onMouseEnter={() => setZoomLevel(zoomScale)}
                         onMouseMove={handleNutritionalMove}
                         onMouseLeave={() => { resetNutritional(); setZoomLevel(1); }}>
                      <img src={infoGarbanzo} alt="Información nutrimental Garbanzo"
                           className="h-full w-auto object-contain drop-shadow-lg filter grayscale transition-transform duration-300"
                           style={{ transformOrigin: nutritionalOrigin, transform: `scale(${zoomLevel})` }} />
                    </div>
                  )}
                  {productoSeleccionado.nombre === 'Haba ' && (
                    <div className="h-40 w-auto overflow-hidden rounded-md shadow-lg cursor-zoom-in"
                         onMouseEnter={() => setZoomLevel(zoomScale)}
                         onMouseMove={handleNutritionalMove}
                         onMouseLeave={() => { resetNutritional(); setZoomLevel(1); }}>
                      <img src={infoHaba} alt="Información nutrimental Haba"
                           className="h-full w-auto object-contain drop-shadow-lg filter grayscale transition-transform duration-300"
                           style={{ transformOrigin: nutritionalOrigin, transform: `scale(${zoomLevel})` }} />
                    </div>
                  )}
                  {productoSeleccionado.nombre === 'Lentejas ' && (
                    <div className="h-40 w-auto overflow-hidden rounded-md shadow-lg cursor-zoom-in"
                         onMouseEnter={() => setZoomLevel(zoomScale)}
                         onMouseMove={handleNutritionalMove}
                         onMouseLeave={() => { resetNutritional(); setZoomLevel(1); }}>
                      <img src={infoLenteja} alt="Información nutrimental Lenteja"
                           className="h-full w-auto object-contain drop-shadow-lg filter grayscale transition-transform duration-300"
                           style={{ transformOrigin: nutritionalOrigin, transform: `scale(${zoomLevel})` }} />
                    </div>
                  )}
                  {productoSeleccionado.nombre === 'Frijol Pinto' && (
                    <div className="h-40 w-auto overflow-hidden rounded-md shadow-lg cursor-zoom-in"
                         onMouseEnter={() => setZoomLevel(zoomScale)}
                         onMouseMove={handleNutritionalMove}
                         onMouseLeave={() => { resetNutritional(); setZoomLevel(1); }}>
                      <img src={infoFrijolPi} alt="Información nutrimental Frijol Pinto"
                           className="h-full w-auto object-contain drop-shadow-lg filter grayscale transition-transform duration-300"
                           style={{ transformOrigin: nutritionalOrigin, transform: `scale(${zoomLevel})` }} />
                    </div>
                  )}
                  {productoSeleccionado.nombre === 'Hojuela de Avena' && (
                    <div className="h-40 w-auto overflow-hidden rounded-md shadow-lg cursor-zoom-in"
                         onMouseEnter={() => setZoomLevel(zoomScale)}
                         onMouseMove={handleNutritionalMove}
                         onMouseLeave={() => { resetNutritional(); setZoomLevel(1); }}>
                      <img src={infoAvena} alt="Información nutrimental Avena"
                           className="h-full w-auto object-contain drop-shadow-lg filter grayscale transition-transform duration-300"
                           style={{ transformOrigin: nutritionalOrigin, transform: `scale(${zoomLevel})` }} />
                    </div>
                  )}
                  {productoSeleccionado.nombre === 'Frijol Negro' && (
                    <div className="h-40 w-auto overflow-hidden rounded-md shadow-lg cursor-zoom-in"
                         onMouseEnter={() => setZoomLevel(zoomScale)}
                         onMouseMove={handleNutritionalMove}
                         onMouseLeave={() => { resetNutritional(); setZoomLevel(1); }}>
                      <img src={infoFrijolN} alt="Información nutrimental Frijol Negro"
                           className="h-full w-auto object-contain drop-shadow-lg filter grayscale transition-transform duration-300"
                           style={{ transformOrigin: nutritionalOrigin, transform: `scale(${zoomLevel})` }} />
                    </div>
                  )}
                  {productoSeleccionado.nombre === 'Arroz' && (
                    <div className="h-40 w-auto overflow-hidden rounded-md shadow-lg cursor-zoom-in"
                         onMouseEnter={() => setZoomLevel(zoomScale)}
                         onMouseMove={handleNutritionalMove}
                         onMouseLeave={() => { resetNutritional(); setZoomLevel(1); }}>
                      <img src={infoArroz} alt="Información nutrimental Arroz"
                           className="h-full w-auto object-contain drop-shadow-lg filter grayscale transition-transform duration-300"
                           style={{ transformOrigin: nutritionalOrigin, transform: `scale(${zoomLevel})` }} />
                    </div>
                  )}
                  {productoSeleccionado.nombre === 'Frijoles Bayos' && (
                    <div className="h-40 w-auto overflow-hidden rounded-md shadow-lg cursor-zoom-in"
                         onMouseEnter={() => setZoomLevel(zoomScale)}
                         onMouseMove={handleNutritionalMove}
                         onMouseLeave={() => { resetNutritional(); setZoomLevel(1); }}>
                      <img src={infoFrijolesB} alt="Información nutrimental Frijoles Bayos"
                           className="h-full w-auto object-contain drop-shadow-lg filter grayscale transition-transform duration-300"
                           style={{ transformOrigin: nutritionalOrigin, transform: `scale(${zoomLevel})` }} />
                    </div>
                  )}
                </div>
              </div>
              <div className="grid md:grid-cols-2 gap-4 mb-4">
                {/* Beneficios */}
                <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-6 border border-green-200">
                  <h4 className="text-xl font-bold text-green-800 mb-4 flex items-center">
                    <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    Beneficios
                  </h4>
                  <ul className="space-y-2">
                    {productoSeleccionado.beneficios?.map((beneficio, index) => (
                      <li key={index} className="flex items-center text-green-700">
                        <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                        <span className="font-medium">{beneficio}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Usos recomendados */}
                <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-6 border border-blue-200">
                  <h4 className="text-xl font-bold text-blue-800 mb-4 flex items-center">
                    <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                    </svg>
                    Usos Recomendados
                  </h4>
                  <ul className="space-y-2">
                    {productoSeleccionado.usos?.map((uso, index) => (
                      <li key={index} className="flex items-center text-blue-700">
                        <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                        <span className="font-medium">{uso}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Características adicionales */}
              <div className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-2xl p-4 border border-gray-200 mb-4">
                <h4 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                  <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                  </svg>
                  Características
                </h4>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                  <div className="bg-white rounded-xl p-3 text-center border border-gray-300">
                    <div className="text-2xl mb-1">🌱</div>
                    <div className="font-semibold text-gray-700 text-sm">100% Natural</div>
                  </div>
                  <div className="bg-white rounded-xl p-3 text-center border border-gray-300">
                    <div className="text-2xl mb-1">✅</div>
                    <div className="font-semibold text-gray-700 text-sm">Certificado</div>
                  </div>
                  <div className="bg-white rounded-xl p-3 text-center border border-gray-300">
                    <div className="text-2xl mb-1">📦</div>
                    <div className="font-semibold text-gray-700 text-sm">Empaque Hermético</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductCatalog;